import React, { useEffect, useState } from "react";

type ServiceStatus = boolean | null;

function getDevBackendStatusUrl(): string {
  const main = (process.env.REACT_APP_MAIN_URL || "").replace(/\/$/, "");
  if (!main) return "/api/status";

  const isPageHttps =
    typeof window !== "undefined" && window.location.protocol === "https:";
  const mainIsLocalhost = /localhost|127\.0\.0\.1/.test(main);

  if (isPageHttps && mainIsLocalhost) {
    return "/api/status";
  }

  return `${main}/status`;
}

async function probe(url: string, timeoutMs = 5000): Promise<boolean> {
  const ctrl = new AbortController();
  const timer = window.setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const response = await fetch(url, {
      method: "GET",
      cache: "no-store",
      signal: ctrl.signal,
    });
    return response.ok;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timer);
  }
}

function statusColor(status: ServiceStatus): string {
  if (status === null) return "#cbd5e1";
  return status ? "#86efac" : "#fca5a5";
}

export default function LocalDevBadge() {
  const [feStatus, setFeStatus] = useState<ServiceStatus>(null);
  const [beStatus, setBeStatus] = useState<ServiceStatus>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;

    let cancelled = false;

    const run = async () => {
      const [feOk, beOk] = await Promise.all([
        probe(`${window.location.origin}/`),
        probe(getDevBackendStatusUrl()),
      ]);

      if (!cancelled) {
        setFeStatus(feOk);
        setBeStatus(beOk);
      }
    };

    run();
    const intervalId = window.setInterval(run, 15_000);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, []);

  if (process.env.NODE_ENV !== "development") return null;

  const branch = process.env.REACT_APP_GIT_BRANCH || "?";

  return (
    <div
      className="position-fixed text-white px-2 py-1"
      style={{
        bottom: 0,
        right: 0,
        zIndex: 99999,
        background: "rgba(0, 120, 50, 0.92)",
        fontSize: "11px",
        fontWeight: 600,
        pointerEvents: "none",
        borderTopLeftRadius: "6px",
        lineHeight: 1.35,
      }}
    >
      <div>DEV · {branch}</div>
      <div style={{ fontSize: "10px", fontWeight: 500, opacity: 0.95 }}>
        <span style={{ marginRight: 10 }}>
          <span
            aria-hidden
            style={{
              display: "inline-block",
              width: 7,
              height: 7,
              borderRadius: "50%",
              marginRight: 4,
              background: statusColor(feStatus),
            }}
          />
          FE
        </span>
        <span>
          <span
            aria-hidden
            style={{
              display: "inline-block",
              width: 7,
              height: 7,
              borderRadius: "50%",
              marginRight: 4,
              background: statusColor(beStatus),
            }}
          />
          BE
        </span>
      </div>
    </div>
  );
}
